import React from 'react';
import styled from 'styled-components/macro';
import * as colors from 'src/styles/colors';

const Wrapper = styled.div<{ color?: string }>`
  display: inline-block;
  border-radius: 20px;
  padding: 5px 26px;
  font-size: 12px;
  font-family: NotoSansTC-Medium;
  color: ${colors.white};
  background-color: ${(props) => props.color};
  white-space: nowrap;
  line-height: 1em;
`;

/** 商標種類代碼標題 */
export const getTmarkClass = (tmarkclass: string) => {
  switch (tmarkclass) {
    case '1':
    case '2':
    case '3':
    case 'T':
    case '4':
    case '5':
    case '6':
    case 'S':
      return '商標';
    case '7':
    case 'C':
      return '證明標章';
    case '8':
    case 'M':
      return '團體標章';
    case 'G':
      return '團體商標';
    default:
      return;
  }
};

/** 商標種類代碼顏色 */
const getTmarkClassColor = (tmarkclass?: string) => {
  switch (tmarkclass) {
    case '商標':
      return colors.primaryBlue_500;
    case '證明標章':
      return colors.primaryEggplant_400;
    case '團體標章':
      return colors.primaryOrange_500;
    case '團體商標':
      return colors.primaryBlue_500;
    default:
      return;
  }
};

interface IProps {
  type: string;
}

/**
 * 商標種類標籤。
 */
const TmarkClassTag: React.FC<IProps> = ({ type }) => {
  return <Wrapper color={getTmarkClassColor(getTmarkClass(type))}>{getTmarkClass(type)}</Wrapper>;
};

export default TmarkClassTag;
